var _defineProperty2;
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/** @module Validators */
var CZECH = 'ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮ';
var POLISH = 'ąćęłńóśźżĄĆĘŁŃÓŚŹŻ';
var BULGARIAN = 'абвгдежзийклмнопрстуфхцчшщъьюяАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯ';
var BG = 'bg';
var CZ = 'cz';
var PL = 'pl';
function createValidator(pattern, error) {
  return function (value) {
    if (value && !pattern.test(value)) {
      return error;
    }
    return null;
  };
}
/**
 * Utility for creating validators for non-standard character sets
 * e.g.
 *
 * const validator = new LocalizedCharacterSet('pl').add('&', '*').toValidator()
 *
 * @class
 */

var LocalizedCharacterSet = /*#__PURE__*/
function () {
  /**
   * @param {String} country - country code
   * @returns {Boolean} canUseLatin1
   */

  /**
   * @param {String} country - country code
   * @param {Boolean} strict - without strict, adds Latin-1 characters
   */
  function LocalizedCharacterSet(country) {
    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, LocalizedCharacterSet);
    _defineProperty(this, "_chars", void 0);
    _defineProperty(this, "_ranges", void 0);
    this._chars = new Set();
    this._ranges = [];
    this.add.apply(this, _toConsumableArray(LocalizedCharacterSet.COUNTRY_CHARS[country]));
    this.addRange('a', 'z');
    this.addRange('A', 'Z');
    if (!strict && LocalizedCharacterSet.canUseLatin1(country)) {
      this.addRange("\xC0", "\xFF");
    }
  }
  _createClass(LocalizedCharacterSet, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, chars = new Array(_len), _key = 0; _key < _len; _key++) {
        chars[_key] = arguments[_key];
      }
      chars.map(function (c) {
        return c.replace('-', '\\-');
      }).forEach(function (char) {
        return _this._chars.add(char);
      });
      return this;
    }
  }, {
    key: "addRange",
    value: function addRange(from, to) {
      this._ranges.push("".concat(from, "-").concat(to));
      return this;
    }
  }, {
    key: "toRegExp",
    value: function toRegExp() {
      return new RegExp("^[".concat(this._ranges.join('')).concat(_toConsumableArray(this._chars).join(''), "]+$"));
    }
  }, {
    key: "toValidator",
    value: function toValidator(error) {
      var pattern = this.toRegExp();
      return function () {
        return createValidator(pattern, error);
      };
    }
  }]);
  return LocalizedCharacterSet;
}();
_defineProperty(LocalizedCharacterSet, "COUNTRIES", {
  BG: BG,
  CZ: CZ,
  PL: PL
});
_defineProperty(LocalizedCharacterSet, "COUNTRY_CHARS", (_defineProperty2 = {}, _defineProperty(_defineProperty2, BG, BULGARIAN), _defineProperty(_defineProperty2, CZ, CZECH), _defineProperty(_defineProperty2, PL, POLISH), _defineProperty2));
_defineProperty(LocalizedCharacterSet, "canUseLatin1", function (country) {
  return [PL, CZ].includes(country);
});
export default LocalizedCharacterSet;